import { Injectable } from '@angular/core';
import { LoadingController, Loading, ToastController, ToastOptions, Toast, AlertController } from 'ionic-angular';
import { TranslateProvider } from '../translate/translate';


/**
 *
 *
 * @export
 * @class UiProvider
 * 
 * Use to get custom loader and toast for UI.
 * and use to get confirmation dialoge box.
 * 
 */
@Injectable()
export class UiProvider {

	constructor(
		private loadingController: LoadingController,
		private toastController: ToastController,
		private alertController: AlertController,
		private translatePrvdr: TranslateProvider
	) { }


	getLoader(): Loading {
		let loader = this.loadingController.create({
			spinner: 'crescent',
			showBackdrop: true
		});
		return loader;
	}

	showError(msg): Toast {

		let config: ToastOptions = {
			message: msg,
			showCloseButton: true,
			duration: 2500,
			cssClass: 'custom__toast custom__toast--error'
		};

		return this.showToast(config);
	}


	showSuccess(msg): Toast {

		let config: ToastOptions = {
			message: msg,
			showCloseButton: true,
			duration: 2500,
			cssClass: 'custom__toast custom__toast--success'
		};

		return this.showToast(config);

	}


	showAlert(msg, subTitle = "") {

		const alert = this.alertController.create({
			title: 'OPYX',
			subTitle: subTitle,
			message: msg,
			buttons: [{
				text: "OK",
				role: "cancel",
			}]
		});

		alert.present();
	}

	showAddToHomeScreenAlert(msg, subTitle = "") {

		const alert = this.alertController.create({
			title: 'OPYX',
			subTitle: "Installeer de app voor meer gebruiksgemak",
			message: '<button class="btn btn-add-to-home" ion-button full (click)="add_to_home(event)">Installeer de nieuwe app!</button>',
			buttons: [{
				text: "OK",
				role: "add_to_home()",
			}]
		});

		alert.present();
	}	

	private showToast(toastOptions: ToastOptions): Toast {

		let toast = this.toastController.create(toastOptions);
		toast.present().then(() => { }, () => { });

		return toast;

	}

	public getConfirmation(subtitle, title = '') {

		return new Promise((resolve, reject) => {

			let alert = this.alertController.create({
				title: title ? title : "Confirm",
				subTitle: subtitle,
				cssClass: "alert__confirmation",
				buttons: [{
					text: "No",
					role: "cancel",
					handler: () => {
						alert.dismiss();
						return false;
					}
				}, {
					text: "Yes",
					handler: () => {
						alert.dismiss(true);
						return false;
					}
				}]
			});

			alert.present();

			alert.onDidDismiss((data) => {

				if (data)
					return resolve();

				return reject();

			});


		});




	}

	public showWarning(title, message ,cssClass) {

		return new Promise((resolve, reject) => {


			const warningAlert = this.alertController.create({
				title: title,
				message: message,
				buttons: [{
					text: this.translatePrvdr.getTranslateKey("OK"),
					role: "cancel",
					handler: () => {
						warningAlert.dismiss(true);
						return false;
					},
					cssClass : "warning__alert--btn"
				}],
				cssClass: cssClass,
				enableBackdropDismiss : false
			})

			warningAlert.present();

			warningAlert.onDidDismiss((data) => {
				if (data) {
					resolve(true);
				} else {
					reject(false);
				}
			})

		})

	}

}



// WEBPACK FOOTER //
// ./src/providers/ui/ui.ts